//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "qstDetail",
    components: {},
    data() {
        return {
            saving: false,
            id: 0,
            questions: [],
            questionnaireInfo: {}
        }
    },
    methods: {
        getQuestionnaireById() {
            abp.ajax.get('/api/services/app/Questionnaire/GetQuestionnaireById?id=' + this.id).then(res => {
                this.questionnaireInfo = {};
                this.questionnaireInfo = res.data.result;
                this.getQuestions();
            });
        },
        getQuestions() {
            abp.ajax.get('/api/services/app/Questionnaire/GetQuestions?id=' + this.id).then(res => {
                this.questions = [];
                this.questions.push(...res.data.result.items);
            });
        },
        saveQuestion() {
            var memberId = localStorage.getItem('MemberId');
            var answerRecord = {
                id: 0,
                questionnaireId: this.id,
                memberId: parseInt(memberId)
            };
            var as = [];
            for (var i = 0; i < this.questions.length; i++) {
                var item = {};
                item = this.questions[i];
                if (!item.result || item.result == '') {
                    this.$toast('第' + (i + 1) + '题未回答');
                    break;
                } else {
                    as.push({
                        id: 0,
                        questionnaireId: this.id,
                        questionId: item.id,
                        answer: item.result.toString()
                    })
                }
            }
            if (as.length < this.questions.length) {
                return;
            }
            answerRecord.answerDetails = as;
            this.saving = true;
            abp.ajax.post('/api/services/app/AnswerRecord/SaveAnswerRecord', answerRecord).then(res => {
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getQuestionnaireById();
        }
    }
}
